import { Box, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { convertConstantLiteralToNormal } from '../../../utils/string.helpers';
import { CheckCircleOutline, PauseCircleOutline } from '@material-ui/icons';

interface RoutingProgressTableProps {
  routingProgress: any;
}

const getStatusCaption = (status: string) => {
  switch (status) {
    case 'RETRY':
      return 'Retrying with more resources';
    default:
      return convertConstantLiteralToNormal(status);
  }
};

export default function RoutingProgressTable({ routingProgress }: RoutingProgressTableProps) {
  return (
    <Table>
      <TableHead>
        <TableCell>Progress</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap', paddingRight: 2 }}>Zone</TableCell>
        <TableCell>Trips</TableCell>
        <TableCell width={'100%'}>Status</TableCell>
      </TableHead>
      <TableBody>
        {Object.values(routingProgress).map((zoneProgress: any, zIndex) => (
          <TableRow key={zIndex}>
            <TableCell>
              <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                <CircularProgress variant="determinate" color="success" size={32} value={zoneProgress.progress} />
                <Box
                  sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    fontSize={'10px'}
                    variant="caption"
                    component="div"
                    sx={{ color: 'text.secondary' }}
                  >{`${Math.round(zoneProgress.progress)}%`}</Typography>
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap', paddingRight: 2 }}>{zoneProgress.zone?.caption ?? ''}</TableCell>
            <TableCell>{zoneProgress.tripsCount}</TableCell>
            <TableCell width={'100%'}>
              {zoneProgress.status == 'CALL_ROUTER' ? (
                <CircularProgress size={16} />
              ) : zoneProgress.status == 'COMPLETED' ? (
                <CheckCircleOutline style={{ height: 20, width: 20, color: 'green' }} />
              ) : zoneProgress.status == 'RETRY' ? (
                <CircularProgress size={16} color="error" />
              ) : (
                <PauseCircleOutline style={{ height: 20, width: 20, color: 'gray' }} />
              )}
              <Typography ml={2} variant="caption">
                {getStatusCaption(zoneProgress.status)}
              </Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
